/* eslint-disable react/style-prop-object */
import React, { useState } from "react";
import ObjectSelectedRows from "../SelectedBody/ObjectSelectedRows";
import { formatDate } from "../../../../JsHelpers/DateFormat";
import axios from "axios";
import { useSelector } from "react-redux";
import trans from "../../../../utils";
import { toast } from "react-toastify";

export default function ObjectSelectedStatus({ position, device }) {
	const { formattedDate, formattedTime } = formatDate(device?.lastUpdate);
	const inf = useSelector((state) => state.users.user);

	const [geoCode, setGeoCode] = useState(false);
	const fetchGeoCodePosition = async (lat, lon) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
			);
			setGeoCode(`${response.data.display_name}`);
			return `${response.data.display_name}`;
		} catch (error) {
			toast.error(trans("Error fetching geocode position:"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	console.log("Status Position", position);

	return (
		<>
			<div className="object-working-status">
				<div className="object-status-details">
					<ObjectSelectedRows
						title={trans("GPS status")}
						item={`${
							device?.status === "online"
								? `${trans("Available")}`
								: `${trans("UnAvailable")}`
						}`}
					/>
				</div>
				<div className="object-status-details">
					<ObjectSelectedRows
						title={trans("Accuracy")}
						item={
							position?.accuracy
								? `${Math.round(position?.accuracy)}`
								: `${trans("N/A")}`
						}
					/>
				</div>
				<div className="object-status-details">
					<ObjectSelectedRows
						title={trans("connectivity")}
						item={`${
							device?.status === "online"
								? `${trans("Connected")}`
								: `${trans("Disconnected")}`
						}`}
					/>
				</div>
				<div className="object-status-details">
					<ObjectSelectedRows
						title={trans("Latitude")}
						item={position?.latitude ? `${position?.latitude}` : "33"}
					/>
				</div>
				<div className="object-status-details">
					<ObjectSelectedRows
						title={trans("Longitude")}
						item={position?.longitude ? `${position?.longitude}` : "30"}
					/>
				</div>
				<div
					className="object-status-details cursor"
					onClick={() => {
						const lat = position ? position.latitude : inf.latitude;
						const lon = position ? position.longitude : inf.longitude;
						fetchGeoCodePosition(lat, lon);
					}}
				>
					<ObjectSelectedRows
						title={trans("Address")}
						item={geoCode ? geoCode : "Get current address"}
						style="text-primary"
					/>
				</div>
				<div className="object-status-details">
					<ObjectSelectedRows
						title={trans("last update")}
						item={
							device?.lastUpdate
								? `${formattedDate + " " + formattedTime}`
								: "N/A"
						}
					/>
				</div>
			</div>
		</>
	);
}
